import React, { useState } from 'react';
import { Modal, IconButton, Button } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import CloseIcon from '@mui/icons-material/Close';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-react';
import './index.scss';

export interface InfoPopupProps {
  fields: {
    'Popup Text': Field<string>;
  };
}

export const InfoPopup = ({ fields }: InfoPopupProps): JSX.Element => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className="info-tooltip">
        <div className="tooltipArea">
          <Button onClick={handleOpen} tabIndex={-1}>
            <HelpIcon />
          </Button>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        className="ws-modal-dialog"
        aria-labelledby="info-popup-title"
        aria-describedby="info-popup-description"
      >
        <div className="infoPopupDialog infoPopupDialogPaper">
          <div className="infoPopup-header">
            <span className="infoPopup-title">Information</span>
            <IconButton
              aria-label="close"
              className="infoPopup-close"
              onClick={handleClose}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
          <RichText
            field={fields?.['Popup Text']}
            className="infoPopup-body"
            id="info-popup-description"
          />
        </div>
      </Modal>
    </>
  );
};

export default InfoPopup;
